import { ComponentContext } from '../types-uischema';
import { ComplexValue } from 'ui';

/**
 * Render cache for connected components when iterating rows of data.
 * We re-use the same component for a column, instead of recreating it for each row.
 */
export interface CacheComponentContext extends ComponentContext {
  primaryKey?: ComplexValue<number>;
}

export interface CacheKey {
  context: CacheComponentContext;
  id: number;
  name: string;
  statePath: string | string[];
}

/**
 * max size to avoid memory leaks
 */
const CACHE_SIZE = 10000;

/**
 * LRU cache would not make any sense since we have to clear whenever UI is re-built
 */
const iteratorCache = new Map();

export const getCachedComponent = (id: CacheKey) => iteratorCache.get(JSON.stringify(id));

export const clearComponentCache = (): void => iteratorCache.clear();

export const getCacheSize = (): number => iteratorCache.size;

export const addComponentToCache = (id: CacheKey, item: React.ComponentClass<any>) => {

  const cacheid = JSON.stringify(id);
 
  if ( iteratorCache.size >= CACHE_SIZE) {
    iteratorCache.clear();
  }

  if (iteratorCache.has(cacheid) === false) {
    iteratorCache.set(cacheid, item);
  }
};
